import { get } from 'lodash'

const state = {
  specialOfferListCurrentPage: 1,
  specialOfferPageListStore: {},
  specialOfferListLastId: '',
  specialOfferSearchCriteria: {
    refCode: '',
    agentId: '',
    hotelId: '',
    promotionId: '',
    specialOfferValid: '',
    agentIdList: [],
    salePersonId: '',
    validBookingDate: '',
    issueStartDate: '',
    issueEndDate: '',
    marketId: '',
    status: ''
  }
}

const getters = {}

const actions = {
  clearMapStateSpecialOfferList (context) {
    const specialOfferSearchCriteria = {
      refCode: '',
      agentId: '',
      hotelId: '',
      promotionId: '',
      specialOfferValid: '',
      agentIdList: [],
      salePersonId: '',
      validBookingDate: '',
      issueStartDate: '',
      issueEndDate: '',
      marketId: '',
      status: ''
    }

    context.commit('setSpecialOfferSearchCriteria', specialOfferSearchCriteria)
    context.commit('setSpecialOfferListCurrentPage', 1)
    context.commit('setSpecialOfferPageListStore', {})
  },
  setSpecialOfferSearchCriteria (context, payLoad) {
    context.commit('setSpecialOfferSearchCriteria', payLoad)
  },
  setSpecialOfferListCurrentPage (context, payLoad) {
    context.commit('setSpecialOfferListCurrentPage', payLoad)
  },
  setSpecialOfferPageListStore (context, payLoad) {
    context.commit('setSpecialOfferPageListStore', payLoad)
  },
  setSpecialOfferListLastId (context, payLoad) {
    context.commit('setSpecialOfferListLastId', payLoad)
  },
  updateSpecialOfferPageListStore (context, payLoad) {
    const pageNumber = payLoad.pageNumber

    if (pageNumber === 1) {
      return
    }

    const specialOfferDetail = payLoad.specialOfferDetail
    const specialOfferPageListStore = context.state.specialOfferPageListStore
    const specialOfferSelectedPageList = specialOfferPageListStore[pageNumber]
    const specialOfferIndex = specialOfferSelectedPageList.findIndex(specialOffer => specialOffer.id === specialOfferDetail.id)

    specialOfferSelectedPageList[specialOfferIndex] = _prepareSpecialOfferListUpdateData(specialOfferDetail)
    context.commit('setSpecialOfferPageListStore', specialOfferPageListStore)
  }
}

const mutations = {
  setSpecialOfferSearchCriteria (state, payLoad) {
    state.specialOfferSearchCriteria = payLoad
  },
  setSpecialOfferListCurrentPage (state, payLoad) {
    state.specialOfferListCurrentPage = payLoad
  },
  setSpecialOfferPageListStore (state, payLoad) {
    state.specialOfferPageListStore = payLoad
  },
  setSpecialOfferListLastId (state, payLoad) {
    state.specialOfferListLastId = payLoad
  }
}

const _prepareSpecialOfferListUpdateData = (specialOfferDetail) => {
  const hotel = get(specialOfferDetail, 'hotel', {})
  const hotelId = get(hotel, 'id', '')
  const startDate = get(specialOfferDetail, 'general.startDate', '')
  const endDate = get(specialOfferDetail, 'general.endDate', '')
  const issueDate = get(specialOfferDetail, 'general.issueDate', '')
  const salePersonTitle = get(hotel, 'salePerson.title', '')
  const salePersonFirstName = get(hotel, 'salePerson.firstName', '')
  const salePersonLastName = get(hotel, 'salePerson.lastName', '')
  const salePersonName = `${salePersonTitle} ${salePersonFirstName} ${salePersonLastName}`
  const agentIdList = specialOfferDetail.agentList.map(agent => agent.id)

  const specialOfferData = {
    id: specialOfferDetail.id,
    hotelId: hotelId,
    promotionId: get(specialOfferDetail, 'promotion.id', ''),
    salePersonId: get(specialOfferDetail, 'salePerson.id', ''),
    status: specialOfferDetail.status,
    startDate: new Date(startDate),
    endDate: new Date(endDate),
    issueDate: new Date(issueDate),
    agentIdList: agentIdList,
    promotionCode: get(specialOfferDetail, 'promotion.code', ''),
    salePersonName: salePersonName,
    refCode: specialOfferDetail.refCode.toUpperCase(),
    updatedAt: new Date()
  }

  return specialOfferData
}

export default {
  name: 'specialOffer',
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
